import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

function DonutGraph(props) {
  const Donut = {
    credits: {
      enabled: false,
    },
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
      height: 170,
      width: 180,
      plotAreaWidth: 300,
      plotAreaHeight: 200,
    },
    title: {
      text: "",
      align: "center",
      verticalAlign: "middle",
      y: 20, // for title top margin
    },
    tooltip: {
      pointFormat: `{series.name}: <b>{point.percentage:.1f}%</b>`,
    },
    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false, // to hide labels
          style: {
            fontWeight: "bold",
            color: "white",
          },
        },
      },
    },
    series: [
      {
        name: props.titles[0],
        type: "pie",
        innerSize: "75%",
        data: [
          { name: props.titles[1], y: props.graphActive },
          { name: props.titles[2], y: props.graphInactive },
          { name: props.titles[3], y: props.graphClosed },
          { name: props.titles[4], y: props.graphDormantDeactive },
        ],
      },
    ],
    colors: props.colors,
  };
  return <HighchartsReact highcharts={Highcharts} options={Donut} />;
}

export default DonutGraph;
